import React from 'react';
import DateRangeHelper from 'fw/forms/helpers/DateRangeHelper'
import { Row, Col } from 'react-bootstrap';
import Combo from '../combo/Combo'
import DatePicker from '../datePicker/DatePicker'
import * as FW from 'fw/system/FW'
import * as Formatting from 'fw/misc/Formatting'

const defaultOption =
    {
        option: "allDates",
        start: "",
        end: ""
    }

class DateRangePicker extends React.Component {
    constructor(props) {
        super(props);

        // Defaul selection to all dates
        let presetOption = defaultOption;

        // Pick between custom options, or standard ones
        const options = props.options || this._getOptions();

        // Find preset within availale options
        if (props.value !== null && props.value !== undefined && props.value !== "") {
            presetOption = props.value;
        }

        this.state = {
            options: options,
            required: props.required,
            value: {
                option: presetOption.option,
                start: presetOption.start,
                end: presetOption.end
            }
        };
    }

    // Public API
    setValue = (value) => {
        this._update(value);
    }

    getValue = () => {
        return this.state.value;
    }

    focus = () => {
        this._combo.focus();
    }

    select = () => {
        this._combo.focus();
    }

    flag = (status) => {
    }

    validate = () => {
        return null;
    }

    completed = () => {
        if (!this.props.required)
            return true;
		else if (this._datePickerStart.completed() && this._datePickerEnd.completed())
            return true;
		else
        	return false;
    }

    // Private
    _getOptions = () => {
        let options = [
            { label: "All dates", value: "allDates", action: new DateRangeHelper().allDates() },
            { label: "Custom", value: "custom", action: new DateRangeHelper().custom() },
            { label: "Today", value: "today", action: new DateRangeHelper().today() },
            { label: "Yesterday", value: "yesterday", action: new DateRangeHelper().yesterday() },
            { label: "This week", value: "thisWeek", action: new DateRangeHelper().thisWeek() },
            { label: "This month", value: "thisMonth", action: new DateRangeHelper().thisMonth() },
            { label: "This year", value: "thisYear", action: new DateRangeHelper().thisYear() },
            { label: "Month-To-Date", value: "monthToDate", action: new DateRangeHelper().MTD() },
            { label: "Year-To-Date", value: "yearToDate", action: new DateRangeHelper().YTD() },
            { label: "Last week", value: "lastWeek", action: new DateRangeHelper().lastWeek() },
            { label: "Last 2 weeks", value: "last2Weeks", action: new DateRangeHelper().last2Weeks() },
            { label: "Last 30 days", value: "last30Days", action: new DateRangeHelper().last30Days() },
            { label: "Last month", value: "lastMonth", action: new DateRangeHelper().lastMonth() },
            { label: "Last quarter", value: "lastQuarter", action: new DateRangeHelper().lastQuarter() },
            { label: "Last 3 months", value: "last3Months", action: new DateRangeHelper().last3Months() },
            { label: "Last 6 months", value: "last6Months", action: new DateRangeHelper().last6Months() },
            { label: "Last year", value: "lastYear", action: new DateRangeHelper().lastYear() },
            { label: "Prior to previous year", value: "last2Years", action: new DateRangeHelper().last2Years() }
        ];

        if (this.props.futureOptions){
            options.push({ label: "Next week", value: "nextWeek", action: new DateRangeHelper().nextWeek() });
            options.push({ label: "Next month", value: "nextMonth", action: new DateRangeHelper().nextMonth() });
            options.push({ label: "Next year", value: "nextYear", action: new DateRangeHelper().nextYear() });
            options.push({ label: "This quarter", value: "thisQuarter", action: new DateRangeHelper().thisQuarter() });
            options.push({ label: "Next quarter", value: "nextQuarter", action: new DateRangeHelper().nextQuarter() });
            options.push({ label: "Year ending", value: "yearEnding", action: new DateRangeHelper().yearEnding() });
        }

        return options;
    }

    _handleComboChange = (newOption) => {
        const optionDates = newOption.action;
        
        this._update({
            option: newOption.value,
            start: Formatting.formatDate(optionDates.start),
            end: Formatting.formatDate(optionDates.end)
        });
    }

    _handleStartChange = (startValue) => {
        this._update({
            option: "custom",
            start: startValue,
            end: this.state.value.end
        });
    }

    _handleEndChange = (endValue) => {
        this._update({
            option: "custom",
            start: this.state.value.start,
            end: endValue
        });
    }

    _update = (value) => {
        this.setState({ value: value }, function () {
            const requiredPassed = this.completed();
            const validationPassed = (this.validate() === null);
            const status = requiredPassed && validationPassed;

            // Show error status if neccesary
            this.flag(status);

            // Trigger parent change events...
            this.props.onChange && this.props.onChange(value);
            this.props.managed && this.props.onFieldChange(value, this.props.name);
        });
    }

    // React
    componentWillReceiveProps(nextProps) {
        // Coming null on the props, we replace by the default option
        if (nextProps.value === null) {
            this.setState({
                value: defaultOption
            });
        }
        else {
            // Deep compare
            if (nextProps.value.option !== this.state.value.option
                || nextProps.value.start !== this.state.value.start
                || nextProps.value.end !== this.state.value.end) {
                this.setState({
                    value: nextProps.value
                });
            }
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.value === null)
            return false;

        if (this.state.value === null)
            return true;

        return (
            nextState.value.option !== this.state.value.option
            || nextState.value.start !== this.state.value.start
            || nextState.value.end !== this.state.value.end
        );
    }

    render() {
        const dateFormat = FW.getSettings().dateFormat;

        const props = {
            locale: this.props.locale,
            dateFormat: this.props.dateFormat || dateFormat,
            closeOnSelect: this.props.closeOnSelect,
            closeOnTab: this.props.closeOnTab,
            required: this.props.required,
            disabled: this.props.disabled
        };

        let startDate = "";
        let endDate = "";

        // Just in case we received some nulls or undefined
        if (this.state.value) {
            startDate = this.state.value.start;
            endDate = this.state.value.end;
        }

        return (
            <React.Fragment>
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        <Combo
                            value={this.state.value.option}
                            items={this.state.options}
                            onChange={this._handleComboChange}
                            placeholder={this.props.placeholder}
                            disabled={this.props.disabled}
                            ref={(c) => { this._combo = c; }} />
                    </Col>
                </Row>
                <Row style={{ marginTop: "5px" }}>
                    <Col xs={12} md={6} lg={6} style={{ paddingRight: "2px" }}>
                        <DatePicker placeholder="from..."
                            key={startDate}
                            value={startDate}
                            onChange={this._handleStartChange}
                            ref={(c) => { this._datePickerStart = c; }} {...props} />
                    </Col>
                    <Col xs={12} md={6} lg={6} style={{ paddingLeft: "2px" }}>
                        <DatePicker placeholder="to..."
                            key={endDate}
                            value={endDate}
                            onChange={this._handleEndChange}
                            ref={(c) => { this._datePickerEnd = c; }} {...props} />
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

export default DateRangePicker;

DateRangePicker.defaultProps = {
    formControl: true,
    managed: false,
    closeOnSelect: true,
    closeOnTab: true,
    futureOptions: true,
	locale: "en",
	placeholder: "Select range..."
};



// WEBPACK FOOTER //
// ./src/fw/forms/controls/dateRangePicker/DateRangePicker.js